import { render, staticRenderFns } from "./SyncAnalytics.vue?vue&type=template&id=2bfdabb8&scoped=true&"
import script from "./SyncAnalytics.vue?vue&type=script&lang=js&"
export * from "./SyncAnalytics.vue?vue&type=script&lang=js&"
import style0 from "./SyncAnalytics.vue?vue&type=style&index=0&id=2bfdabb8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bfdabb8",
  null
  
)

export default component.exports